<ng-container *ngIf="data.isFormio;else showTable">
	<div class="content-align" [dir]="data.dir">
		<formio [formKey]="data.formKey" [submission]="data.submission" (beforeSubmit)="beforeSubmit($event)"
			(customEvent)="customEvent($event)"></formio>
	</div>
</ng-container>

<ng-template #showTable>
	<div class="mx-4 my-4" [dir]="data.dir">
		<div class="d-flex justify-content-between align-items-baseline">
			<h4 class="font-weight-bold">
				{{ 'forms.common.' + data.title | translate }} - {{ 'forms.common.' + roles[data.submission.data.role] |
				translate}}
			</h4>

			<button mat-icon-button matTooltip="{{ 'forms.common.orgReviewersFilters' | translate }}"
				(click)="expandedFilter=!expandedFilter;">
				<mat-icon>filter_alt</mat-icon>
			</button>
		</div>


		<mat-accordion [ngClass]="{'d-none': !expandedFilter}">
			<mat-expansion-panel [expanded]="expandedFilter">
				<app-org-reviewer-filter (onSearch)="searchWithReset($event)"
					(onClear)="onClear()"></app-org-reviewer-filter>
			</mat-expansion-panel>
		</mat-accordion>

		<div class="data-table">
			<div class="loading-shade" *ngIf="isLoadingResults">
				<mat-spinner [diameter]="50"></mat-spinner>
			</div>

			<ng-container *ngIf="dataSource$ | async as dataSource">
				<table mat-table [dataSource]="dataSource.data" matSort (matSortChange)="sortData($event)">
					<ng-container matColumnDef="name">
						<th mat-header-cell *matHeaderCellDef>
							<strong> {{ "forms.common.name" | translate }}</strong>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="content">{{ row | propertyLocalized : ['arabicName','englishName'] | async
								}}
							</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="gender">
						<th mat-header-cell *matHeaderCellDef>
							<strong> {{ "forms.common.Gender" | translate }}</strong>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="content" *ngIf="row?.gender">{{ 'forms.common.' + row?.gender | translate}}
							</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="nationality">
						<th mat-header-cell *matHeaderCellDef>
							<strong> {{ "forms.common.nationality" | translate }}</strong>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="content" *ngIf="row?.nationality">{{ 'forms.common.' + row?.nationality |
								translate}}
							</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="residenceCountry">
						<th mat-header-cell *matHeaderCellDef>
							<strong> {{ "forms.common.ResidenceCountry" | translate }}</strong>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="content" *ngIf="row?.residenceCountry">{{ 'forms.common.' +
								row?.residenceCountry |
								translate}}</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="residencePlace">
						<th mat-header-cell *matHeaderCellDef>
							<strong> {{ "forms.common.ResidencePlace" | translate }}</strong>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="content" *ngIf="row?.residencePlace">{{ 'forms.common.' +
								row?.residencePlace |
								translate}}</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="residenceCity">
						<th mat-header-cell *matHeaderCellDef>
							<strong> {{ "forms.common.ResidenceCity" | translate }}</strong>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="content" *ngIf="row?.residenceCity">{{ 'forms.common.' +
								row?.residenceCity |
								translate}}</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="workDestination">
						<th mat-header-cell *matHeaderCellDef>
							<strong> {{ "forms.common.workSide" | translate }}</strong>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="content" *ngIf="row?.workDestination">{{ row?.workDestination}}</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="generalSpecialty">
						<th mat-header-cell *matHeaderCellDef>
							<strong> {{ "forms.common.publicSpecialty" | translate }}</strong>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="content">{{ 'forms.common.' + row?.generalSpecialty | translate}}</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="reviewerState">
						<th mat-header-cell *matHeaderCellDef mat-sort-header="reviewerState">
							<strong> {{ "forms.common.reviewerState" | translate }}</strong>
						</th>
						<td mat-cell *matCellDef="let row">
							<div class="content">{{ "forms.common." + row?.reviewerState | translate }}</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="details">
						<th mat-header-cell *matHeaderCellDef>
							{{'forms.common.Details' | translate}}
						</th>
						<td mat-cell *matCellDef="let row">
							<i class="fa fa-eye icon" pTooltip="{{'forms.common.Details' | translate}}"
								(click)="showDetails($event,row)"></i>
						</td>
					</ng-container>

					<ng-container matColumnDef="actions">
						<th mat-header-cell *matHeaderCellDef>
						</th>
						<td mat-cell *matCellDef="let row;let i = index" style="width: 50px">
							<div class="d-flex justify-content-center">
								<mat-radio-group [(ngModel)]="selectedRow">
									<mat-radio-button [value]="row"></mat-radio-button>
								</mat-radio-group>
							</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="noRecord">
						<td colspan="5" class="text-center" mat-footer-cell *matFooterCellDef>
							{{ "forms.common.No items added yet" | translate }}
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'deleted': row?.deleted}"
						(click)="selectRow(row)">
					</tr>

					<tr [hidden]="!!dataSource?.data?.length" mat-footer-row *matFooterRowDef="
				dataSource?.data?.length === 0 ? ['noRecord'] : []
				"></tr>
				</table>
				<mat-paginator *ngIf="dataSource?.totalItems" [length]="dataSource?.totalItems" [pageSize]="pageSize"
					(page)="changePage($event)">
				</mat-paginator>
			</ng-container>
		</div>

		<div class="d-flex justify-content-end">
			<button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.viewOnly}">
				{{ "forms.common.cancel" | translate }}
			</button>

			<button *ngIf="!data.viewOnly" class="mt-3" mat-flat-button color="primary" [disabled]="!selectedRow"
				(click)="save()">
				{{ "forms.common.save" | translate }}
			</button>
		</div>
	</div>
</ng-template>
